import BillingsComponent from "../Billings"

const SettingsBilling = () => {
    return(
        <BillingsComponent />
    )
}

export default SettingsBilling